// @mui
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// components
import { Helmet } from 'react-helmet-async';
import { Autocomplete, Button, TextField } from '@mui/material';
import useSelectSystem from './useSelectSystem';
import PasswordIcon from '../../assets/icons/password-icon';

const SelectSystemPagePage = () => {

    const { userSystems, selectedSystem, setSelectedSystem, userBranches, selectedBranch, setSelectedBranch, confirmSystem } = useSelectSystem();

    return (
        <>
            <Helmet>
                <title>Gerenciamento Cenix</title>
            </Helmet>
            <PasswordIcon sx={{ height: 96 }} />

            <Stack spacing={1} sx={{ my: 5 }}>
                <Typography variant="h3">Selecione o Sistema</Typography>                
            </Stack>
            <Stack spacing={2.5} sx={{ mt: 4 }}>
                <Autocomplete
                    options={userBranches}
                    fullWidth
                    renderInput={(params) => <TextField {...params} label="Filiais" placeholder='Selecione...' />}
                    getOptionLabel={(option) => option.code + ' - ' + option.name}
                    value={selectedBranch}
                    onChange={(e: unknown, newValue: any) => setSelectedBranch(newValue)}
                />
                <Autocomplete
                    options={userSystems}
                    fullWidth
                    renderInput={(params) => <TextField {...params} label="Sistema" placeholder='Selecione...' />}
                    getOptionLabel={(option) => option.name}
                    value={selectedSystem}
                    onChange={(e: unknown, newValue: any) => setSelectedSystem(newValue)}
                />
                <Button
                    fullWidth
                    color="inherit"
                    size="large"
                    type="submit"
                    variant="contained"
                    sx={{ mt: 4 }}
                    onClick={confirmSystem}
                    disabled={!selectedSystem}
                >
                    Confirmar
                </Button>
            </Stack>
        </>
    );

}

export default SelectSystemPagePage;